export enum Page {
  OnBoarding = 'on-boarding',
  Login = 'login',
  Consent = 'consent',
  TermsOfUse = 'terms-of-use',
  Report = 'report',
  Confirmation = 'confirmation',
  Contact = 'contact',
  Inform = 'inform'
}

export enum OnBoardingStep {
  One = 'one',
  Two = 'two',
  Three = 'three'
}
